/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlOnboardingActionItems } from './ControlOnboardingActionItems';
import {
    ControlOnboardingActionItemsFromJSON,
    ControlOnboardingActionItemsFromJSONTyped,
    ControlOnboardingActionItemsToJSON,
} from './ControlOnboardingActionItems';

/**
 * 
 * @export
 * @interface ControlLoginWithOnboardingActionItemsResponse
 */
export interface ControlLoginWithOnboardingActionItemsResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlLoginWithOnboardingActionItemsResponse
     */
    access_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLoginWithOnboardingActionItemsResponse
     */
    mfa_token?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlLoginWithOnboardingActionItemsResponse
     */
    is_mfa_enrolled: boolean;
    /**
     * 
     * @type {Array<ControlOnboardingActionItems>}
     * @memberof ControlLoginWithOnboardingActionItemsResponse
     */
    onboarding_action_items?: Array<ControlOnboardingActionItems>;
}

/**
 * Check if a given object implements the ControlLoginWithOnboardingActionItemsResponse interface.
 */
export function instanceOfControlLoginWithOnboardingActionItemsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_mfa_enrolled" in value;

    return isInstance;
}

export function ControlLoginWithOnboardingActionItemsResponseFromJSON(json: any): ControlLoginWithOnboardingActionItemsResponse {
    return ControlLoginWithOnboardingActionItemsResponseFromJSONTyped(json, false);
}

export function ControlLoginWithOnboardingActionItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlLoginWithOnboardingActionItemsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access_token': !exists(json, 'access_token') ? undefined : json['access_token'],
        'mfa_token': !exists(json, 'mfa_token') ? undefined : json['mfa_token'],
        'is_mfa_enrolled': json['is_mfa_enrolled'],
        'onboarding_action_items': !exists(json, 'onboarding_action_items') ? undefined : ((json['onboarding_action_items'] as Array<any>).map(ControlOnboardingActionItemsFromJSON)),
    };
}

export function ControlLoginWithOnboardingActionItemsResponseToJSON(value?: ControlLoginWithOnboardingActionItemsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'access_token': value.access_token,
        'mfa_token': value.mfa_token,
        'is_mfa_enrolled': value.is_mfa_enrolled,
        'onboarding_action_items': value.onboarding_action_items === undefined ? undefined : ((value.onboarding_action_items as Array<any>).map(ControlOnboardingActionItemsToJSON)),
    };
}

